<script setup lang="ts">
import type { NonUndefined } from "@shared/utils/nonUndefined";

import type { PageStoryblok } from "#storyblok-components";

defineProps<{
  blok?: NonUndefined<PageStoryblok["body"]>[number];
}>();
</script>

<template>
  <StoryblokComponent
    v-if="blok && isStoryblokContentForWeb(blok.showOn)"
    :blok="blok"
  />
</template>
